module.exports = __webpack_public_path__ + "img/linkedin.8f606b01.svg";